import { render, staticRenderFns } from "./ExportPageEdgeText.vue?vue&type=template&id=1a2a9e95&scoped=true"
import script from "./ExportPageEdgeText.vue?vue&type=script&lang=js"
export * from "./ExportPageEdgeText.vue?vue&type=script&lang=js"
import style0 from "./ExportPageEdgeText.vue?vue&type=style&index=0&id=1a2a9e95&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2a9e95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a2a9e95')) {
      api.createRecord('1a2a9e95', component.options)
    } else {
      api.reload('1a2a9e95', component.options)
    }
    module.hot.accept("./ExportPageEdgeText.vue?vue&type=template&id=1a2a9e95&scoped=true", function () {
      api.rerender('1a2a9e95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/Export/components/ExportPageEdgeText.vue"
export default component.exports